import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
var DndSortableElement = function (_a) {
    var dndType = _a.dndType, children = _a.children, id = _a.id, position = _a.position, onDrop = _a.onDrop, onHover = _a.onHover, onDragBegin = _a.onDragBegin, onDragEnd = _a.onDragEnd, _b = _a.isSortable, isSortable = _b === void 0 ? true : _b;
    var ref = useRef(null);
    var _c = useDrop({
        accept: dndType,
        drop: function (item) {
            if (!ref.current) {
                return;
            }
            onDrop(position);
        },
        hover: function (item) {
            if (!ref.current) {
                return;
            }
            if (id !== item.id) {
                onHover(position);
            }
        },
        canDrop: function (item, monitor) {
            return isSortable;
        },
    }), drop = _c[1];
    var _d = useDrag({
        item: { type: dndType, id: id },
        begin: function () { return onDragBegin(id, position); },
        end: onDragEnd,
        canDrag: isSortable,
    }), drag = _d[1];
    drag(drop(ref));
    return children({ ref: ref });
};
DndSortableElement.displayName = 'DndSortableElement';
export default DndSortableElement;
//# sourceMappingURL=DndSortableElement.js.map